import TextInputField from 'components/fields/text-input-field/text-input-field.component'
import FormTwoColumnLayout from 'layouts/form-two-column-layout/form-two-column-layout'
import FormSingleColumnLayout from 'layouts/form-single-column-layout/form-single-column-layout'
import DatePickerField from 'components/fields/date-range-picker-field/date-range-picker-field.component'
import TimeInputField from 'components/fields/time-input-field/time-input-field.component'
import { LoadConfirmFormContainer } from 'components/forms/forms.styles'
import { useStopDateTimeSync } from '../utils/use-stop-datetime-sync'
import { LoadConfirmationStopActions } from '../components/load-confirmation-stop-actions'

type LoadConfirmationPickupFormProps = {
  stopIndex: number
  hasTransportStops: boolean
  onAddPickupDelivery: () => void
  onChangePickupDelivery: () => void
}

export function LoadConfirmationPickupForm({
  stopIndex,
  hasTransportStops,
  onAddPickupDelivery,
  onChangePickupDelivery,
}: LoadConfirmationPickupFormProps) {
  const { startTimeOnlyField, endTimeOnlyField, basePath } = useStopDateTimeSync(
    'pickups',
    stopIndex
  )

  return (
    <LoadConfirmationStopActions
      hasTransportStops={hasTransportStops}
      showEmptyState
      onAddPickupDelivery={onAddPickupDelivery}
      onChangePickupDelivery={onChangePickupDelivery}
    >
      <LoadConfirmFormContainer
        container
        spacing={2}
        $compact
        data-testid="LoadConfirmation.Pickup.Form"
        sx={{ px: 0, pt: 0 }}
      >
        <FormTwoColumnLayout>
          <DatePickerField
            label="Start Pickup Date"
            name={`${basePath}.startTime`}
            highlight
            hideIcon
          />
          <DatePickerField
            label="End Pickup Date"
            name={`${basePath}.endTime`}
            highlight
            hideIcon
          />
          <TimeInputField
            label="Pickup Time From"
            name={startTimeOnlyField}
            highlight
            hideSelectIcon
          />
          <TimeInputField
            label="Pickup Time To"
            name={endTimeOnlyField}
            highlight
            hideSelectIcon
          />
        </FormTwoColumnLayout>

        <FormSingleColumnLayout>
          <TextInputField
            label="Pickup Company Name"
            name={`${basePath}.name`}
            highlight
          />
          <TextInputField
            label="Pickup Company Address"
            name={`${basePath}.address`}
            highlight
          />
        </FormSingleColumnLayout>

        <FormTwoColumnLayout>
          <TextInputField label="FTL or LTL" name={`${basePath}.loadType`} />
          <TextInputField label="Load Count" name={`${basePath}.loadCount`} />
          <TextInputField label="Temp" name={`${basePath}.temperatureValue`} />
          <TextInputField label="Hazmat" name={`${basePath}.hazmat`} />
          <TextInputField label="Pickup#" name={`${basePath}.pickupNumber`} />
          <TextInputField label="Weight" name={`${basePath}.weightValue`} />
        </FormTwoColumnLayout>

        <FormSingleColumnLayout>
          <TextInputField
            label="Shipment Notes"
            name={`${basePath}.notes`}
            multiline
            minRows={3}
          />
        </FormSingleColumnLayout>
      </LoadConfirmFormContainer>
    </LoadConfirmationStopActions>
  )
}
